import { Box } from "@mui/material";
import { ProgressBar } from "./ProgressBar";

export const Progress = ({
  primaryValue,
  secondaryValue,
}: {
  primaryValue: number;
  secondaryValue: number;
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "48px",
        backgroundColor: "#F7F7F7",
      }}
    >
      {primaryValue > 0 && (
        <ProgressBar color="#1B3967" value={primaryValue} zIndex={3} />
      )}
      {secondaryValue > 0 && (
        <ProgressBar
          color="#FE8836"
          value={primaryValue + secondaryValue}
          zIndex={2}
        />
      )}
    </Box>
  );
};
